import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/on-premise/page';

export const Route = createFileRoute('/_app/settings/on-premise/')({
  component: Page,
});
